import { API_URL } from "../../api/RequestConstants";

const articleAPICall = async (url, method, body = null) => {
    const requestOptions = {
        method: method,
        headers: {
            'Accept': 'application/json'
        },
        body: body,
    };

    const response = await fetch(API_URL + url, requestOptions);
    if (!response.ok) {
        console.log(`Failed to ${method} article: ${response.status} ${response.statusText}`);
    }

    if (response.status === 204) {
        return response;
    }

    return await response.json();
};

const validateArticleData = (title, author_name, hashtags, content, meta_title, meta_alt) => {
    if (!title || title.trim() === '') {
        throw new Error('Пустое название');
    }
    if (title.length > 255) {
        throw new Error('Название длинее чем 255 символов');
    }

    if (!author_name || author_name.trim() === '') {
        throw new Error('Пустое имя автора');
    }
    if (author_name.length > 255) {
        throw new Error('Имя автора длинее чем 255 символов');
    }

    if (!hashtags || hashtags.trim() === '') {
        throw new Error('Пустое поле Хэштегов');
    }
    if (hashtags.length > 512) {
        throw new Error('Хэштеги длинее чем 512 символов');
    }

    if (!content || content.trim() === '') {
        throw new Error('Тело статьи пустое');
    }

    if (meta_title && meta_title.length > 255) {
        throw new Error('Поле meta_title должно быть не длинее чем 255 символов')
    }

    if (meta_alt && meta_alt.length > 255) {
        throw new Error('Поле meta_alt должно быть не длинее чем 255 символов')
    }
};

const updateArticleCache = (data, editMode) => {
    let newsList = window.sessionStorage.getItem("newsList");
    newsList = newsList ? JSON.parse(newsList) : [];

    let newsContent = window.sessionStorage.getItem("newsContent");
    newsContent = newsContent ? JSON.parse(newsContent) : [];

    newsContent[data.id] = structuredClone(data);
    delete data.content;
    if (editMode && newsList.length > 0) {
        for (let i = 0; i < newsList.length; i++) {
            if (newsList[i].id === data.id) {
                newsList[i] = data;
                break;
            }
        }
    } else {
        newsList.unshift(data);
    }

    window.sessionStorage.setItem("newsList", JSON.stringify(newsList));
    window.sessionStorage.setItem("newsContent", JSON.stringify(newsContent));
};

const createFormData = (title, author_name, hashtags, content, banner, meta_title, meta_alt) => {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('author_name', author_name);
    formData.append('hashtags', hashtags);
    formData.append('content', content);
    formData.append('banner[meta_title]', meta_title);
    formData.append('banner[meta_alt]', meta_alt);

    if (banner != null) {
        formData.append('banner[image]', banner);
    }

    return formData;
};

const createArticle = async (title, author_name, hashtags, content, banner, meta_title, meta_alt) => {
    try {
        validateArticleData(title, author_name, hashtags, content, meta_title, meta_alt);
    } catch (err) {
        throw err;
    }
    content = content.replace(/&nbsp;/g, ' ');

    const formData = createFormData(title, author_name, hashtags, content, banner, meta_title, meta_alt);

    const response = await articleAPICall('/article', 'POST', formData);
    if (response.success) {
        updateArticleCache(response.data, false);
    }
    return response;
};

const editArticle = async (id, title, author_name, hashtags, content, banner, meta_title, meta_alt) => {
    if ((typeof id !== 'number' && !isFinite(id)) || id < 0) {
        throw new Error('Неверный ID');
    }

    try {
        validateArticleData(title, author_name, hashtags, content, meta_title, meta_alt);
    } catch (err) {
        throw err;
    }

    content = content.replace(/&nbsp;/g, ' ');

    const formData = createFormData(title, author_name, hashtags, content, banner, meta_title, meta_alt);
    formData.append('_method', 'PUT');

    const response = await articleAPICall('/article/' + id, 'POST', formData);
    if (response.success) {
        updateArticleCache(response.data, true);
    }
    return response;
};

const deleteArticle = async (id) => {
    if ((typeof id !== 'number' && !isFinite(id)) || id < 0) {
        throw new Error('Неверный ID');
    }

    const response = await articleAPICall('/article/' + id, 'DELETE');

    if (!response.ok)
    {
        throw new Error('Something went wrong');
    }

    let newsList = window.sessionStorage.getItem("newsList");
    let newsContent = window.sessionStorage.getItem("newsContent");

    if (newsList) {
        newsList = JSON.parse(newsList);
        newsList = newsList.filter(item => item.id !== id);
        window.sessionStorage.setItem("newsList", JSON.stringify(newsList));
    }

    if (newsContent) {
        newsContent = JSON.parse(newsContent);
        delete newsContent[id];
        window.sessionStorage.setItem("newsContent", JSON.stringify(newsContent));
    }

    return response;
}

export {createArticle, editArticle, deleteArticle};